import type {PlaceId} from '@jetbrains/teamcity-ui/plugin'

import Plugin from '../Plugin/Plugin'
import PluginWrapper from '../Plugin/PluginWrapper/PluginWrapper'

interface AiAssistantChatButtonWrapperProps {
  isClassicUi?: boolean
  placeId: PlaceId
}

function AiAssistantChatButtonWrapper({
  placeId,
  isClassicUi = false,
}: AiAssistantChatButtonWrapperProps) {
  if (isClassicUi) {
    return null
  }

  return (
    <PluginWrapper placeId={placeId}>
      <Plugin placeId={placeId} />
    </PluginWrapper>
  )
}

export default AiAssistantChatButtonWrapper
